import { AffiliateBaseThemeType, ChatBaseThemeType, TapBaseThemeType } from '../theme';

type ThemeMode = 'light' | 'dark';

export type RecursiveThemeValue<T> = {
  [K in keyof T]: T[K] extends { light: infer L; dark: infer D }
    ? L | D // light와 dark가 있는 경우 선택
    : T[K] extends object // 중첩된 객체일 경우 재귀 호출
      ? RecursiveThemeValue<T[K]>
      : T[K]; // 최종 값
};
/**
 * @todo - 베이스 테마 타입을 제대로 구체화해야 함 (지금은 typeof 연산자로 타입 추론)
 */
export const createTheme = <T extends ChatBaseThemeType | AffiliateBaseThemeType | TapBaseThemeType>(
  mode: ThemeMode,
  baseTheme: T
) => {
  // const getValueByMode = <V>(value: any):any=> {
  //   // 객체의 `light`와 `dark` 속성에 따라 최종 값을 반환
  //   if (value && typeof value === 'object' && 'light' in value && 'dark' in value) {
  //     return (value as any)[mode] || (value as any)['light'];
  //   }
  //   // 객체가 중첩된 경우, 재귀적으로 각 속성의 최종 값을 반환
  //   if (value && typeof value === 'object') {
  //     return Object.fromEntries(Object.entries(value).map(([key, val]) => [key, getValueByMode(val)])) as any;
  //   }
  //   return value as any; // 이미 최종 값인 경우 그대로 반환
  // };
  // 재귀적으로 theme 값을 탐색하고 반환
  const getValueByMode = <T>(value: T, mode: ThemeMode): RecursiveThemeValue<T> => {
    if (value && typeof value === 'object' && 'light' in value && 'dark' in value) {
      return (value as any)[mode] || (value as any)['light']; // mode에 해당하는 값 반환
    }

    if (value && typeof value === 'object') {
      return Object.fromEntries(
        Object.entries(value).map(([key, val]) => [key, getValueByMode(val, mode)])
      ) as RecursiveThemeValue<T>;
    }

    return value as RecursiveThemeValue<T>;
  };

  // 3단계 깊이까지 탐색하면서 각 값이 문자열로 반환되도록 설정
  return getValueByMode(baseTheme, mode);
};
